import React from "react";
import styles from "./Link.scss";

const Link = props => {
  const {
    useModal = false,
    toggleNewsModal = () => {},
    basePath = "/",
    newsItem,
    className = "",
    content
  } = props;

  const _toggleNewsModal = event => {
    event.preventDefault();
    toggleNewsModal(newsItem);
  };

  if (useModal) {
    return (
      <button
        className={`${className} ${styles.link}`}
        onClick={_toggleNewsModal}
      >
        {content}
      </button>
    );
  } else {
    return (
      <a
        className={`${className} ${styles.link}`}
        href={basePath + newsItem.slug}
      >
        {content}
      </a>
    );
  }
};

export default Link;
